import { z } from 'zod';

/**
 * Lifecycle status of an Org (unified Business + Carrier collection).
 * Mirrors the existing `statusCommonSchema` values used by the legacy
 * Business and Carrier collections so the dual-write transition is a
 * no-op for status semantics.
 *
 * - `active`   — verified, can transact
 * - `pending`  — onboarded but not yet verified
 * - `inactive` — paused by the org or by Hero
 * - `blocked`  — Hero-side block (compliance, fraud, etc.)
 */
export const orgStatusSchema = z.enum(['active', 'pending', 'inactive', 'blocked']);
export type OrgStatus = z.infer<typeof orgStatusSchema>;
